import React from "react";

import { api } from "@/utils/api";

class AgreementSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      contentText: "",
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getPublishProtocal()
      .then((response) => {
        this.setState({
          title: response[0].loginTitle,
          contentText: response[0].contentText,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  render() {
    const { contentText, title } = this.state;
    return (
      <div className="agreement-container">
        <div className="title">{title}</div>
        <div
          dangerouslySetInnerHTML={{
            __html: contentText,
          }}
        />
      </div>
    );
  }
}

export default AgreementSection;
